module.exports = __webpack_public_path__ + "img/indo-win.38306a1c.png";